class Store {
  constructor(axios) {
    this.axios = axios
    this.state = {}
    this.translations = {}
  }

  getRootFolder() {
    return this.axios.get('root').then(({data}) => {
      this.state = Object.assign({}, this.state, { folder: data })
    })
  }

  getTrashFolder() {
    return this.axios.get('trash').then(({data}) => {
      this.state = Object.assign({}, this.state, { folder: data })
    })
  }

  getItems(params) {
    this.state = Object.assign({}, this.state, { items: [], meta: {} })

    return this.axios.get('items', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { items: data.data, meta: data.meta })
    })
  }

  bulkCreateFolders(params) {
    return this.axios.post(`bulk/folders/bulk_create`, params)
  }

  bulkMoveFolders(params) {
    return this.axios.post(`bulk/folders/bulk_move`, params)
  }

  bulkDeleteFolders(params) {
    return this.axios.post(`bulk/folders/bulk_destroy`, params)
  }

  bulkMoveRecords(params) {
    return this.axios.post(`bulk/records/bulk_move`, params)
  }

  bulkDeleteRecords(params) {
    return this.axios.post(`bulk/records/bulk_destroy`, params)
  }

  bulkDeleteProducts(params) {
    return this.axios.delete(`bulk/products`, params)
  }

  bulkCreateRecordSubscription(params) {
    return this.axios.post(`bulk/records/subscribe`, params)
  }

  createUser(params) {
    return this.axios.post('users', params)
  }

  updateUser(user, params) {
    return this.axios.patch(`users/${user.id}`, params)
  }

  verifyAccount(params) {
    return this.axios.patch(`public/verify_accounts`, params)
  }

  getTemplates() {
    return this.axios.get('request_templates').then(({data}) => {
      this.state = Object.assign({}, this.state, { templates: data })
    })
  }

  createTemplate(params) {
    return this.axios.post('request_templates', params)
  }

  destroyTemplate(templateId) {
    return this.axios.delete(`request_templates/${templateId}`)
  }

  getSignatures() {
    return this.axios.get('request_signatures').then(({data}) => {
      this.state = Object.assign({}, this.state, { signatures: data })
    })
  }

  getDefaultSignature() {
    return this.axios.get('request_signatures/default_value').then(({data}) => {
      this.state = Object.assign({}, this.state, { default_signature: data })
    })
  }

  createSignature(params) {
    return this.axios.post('request_signatures', params)
  }

  destroySignature(signatureId) {
    return this.axios.delete(`request_signatures/${signatureId}`)
  }

  getSharedFolders(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('shared_folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedFolders: data.data, meta: data.meta })
    })
  }

  getSharedFolder(folderId, params) {
    return this.axios.get(`shared_folders/${folderId}`, {params: params}).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedFolder: data })
    })
  }

  getSharedFolderChecklist(sharedFolderId) {
    return this.axios.get(`shared_folders/${sharedFolderId}/checklist_items`).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedFolderChecklist: data })
    })
  }

  getMySharedFolders(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('my_shared_folders', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { mySharedFolders: data.data, meta: data.meta })
    })
  }

  revokeMySharedFolders(folder_id) {
    return this.axios.delete(`my_shared_folders/${folder_id}`)
  }

  revokeBulkMySharedFolders(folderIds) {
    return this.axios.post(`my_shared_folders/bulk_destroy`, {'ids': folderIds})
  }

  createSharedRecord(params) {
    return this.axios.post('shared_records', params)
  }

  copySharedRecord(recordId, params) {
    return this.axios.post(`shared_records/${recordId}/copy`, params)
  }

  destroySharedRecord(recordId) {
    return this.axios.delete(`shared_records/${recordId}`)
  }

  updateSharedRecord(recordId, params) {
    return this.axios.patch(`shared_records/${recordId}`, params)
  }

  getSharedFolderSubscription(folderId) {
    return this.axios.get(`shared_folders/${folderId}/subscriptions`).then(({data}) => {
      this.state = Object.assign({}, this.state, { folderSubscription: data })
    })
  }

  deleteSharedFolderSubscription(folderId, subscriptionId) {
    return this.axios.delete(`shared_folders/${folderId}/subscriptions/${subscriptionId}`)
  }

  createSharedFolderSubscription(folderId, params) {
    return this.axios.post(`shared_folders/${folderId}/subscriptions`, params)
  }

  getFolder(folderId) {
    return this.axios.get(`folders/${folderId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, { folder: data })
      return data
    })
  }

  createFolder(params) {
    return this.axios.post('folders', params)
  }

  updateFolder(folderId, params) {
    return this.axios.patch(`folders/${folderId}`, params)
  }

  destroyFolder(folderId) {
    return this.axios.delete(`folders/${folderId}`)
  }

  getFolderSubscription(folderId) {
    return this.axios.get(`folders/${folderId}/subscriptions`).then(({data}) => {
      this.state = Object.assign({}, this.state, { folderSubscription: data })
    })
  }

  deleteFolderSubscription(folderId, subscriptionId) {
    return this.axios.delete(`folders/${folderId}/subscriptions/${subscriptionId}`)
  }

  createFolderSubscription(folderId, params) {
    return this.axios.post(`folders/${folderId}/subscriptions`, params)
  }

  getRecordSubscription(recordId) {
    return this.axios.get(`records/${recordId}/subscriptions`).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordSubscription: data })
    })
  }

  deleteRecordSubscription(recordId, subscriptionId) {
    return this.axios.delete(`records/${recordId}/subscriptions/${subscriptionId}`)
  }

  createRecordSubscription(recordId, params) {
    return this.axios.post(`records/${recordId}/subscriptions`, params)
  }

  shareFolder(folderId, params) {
    return this.axios.post(`/folders/${folderId}/share_invites`, params)
  }

  getContacts(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('contacts', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { contacts: data.data, meta: data.meta })
    })
  }

  recommendContact(params) {
    return this.axios.post(`/contacts/recommend`, params)
  }

  getContact(contactId) {
    return this.axios.get(`contacts/${contactId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, { contact: data })
    })
  }

  getOrgMessages(contactId) {
    return this.axios.get(`contacts/${contactId}/messages_org`).then(({data}) => {
      this.state = Object.assign({}, this.state, { messages_org: data })
    })
  }

  updateContact(contactId, params) {
    return this.axios.patch(`contacts/${contactId}`, params)
  }

  updateContactPage(params) {
    return this.axios.patch('contact_pages', params)
  }

  getDocumentResponses(contactId) {
    this.axios.get(`contacts/${contactId}/document_responses`).then(({data}) => {
      this.state = Object.assign({}, this.state, { documentResponses: data })
    })
  }

  getUploadResponses(contactId) {
    this.axios.get(`contacts/${contactId}/upload_responses`).then(({data}) => {
      this.state = Object.assign({}, this.state, { uploadResponses: data })
    })
  }

  getVersionResponses(contactId) {
    this.axios.get(`contacts/${contactId}/version_responses`).then(({data}) => {
      this.state = Object.assign({}, this.state, { versionResponses: data })
    })
  }

  getVersionRequests(contactId) {
    this.axios.get(`contacts/${contactId}/version_requests`).then(({data}) => {
      this.state = Object.assign({}, this.state, { versionRequests: data })
    })
  }

  getDocumentRequests(contactId) {
    this.axios.get(`contacts/${contactId}/document_requests`).then(({data}) => {
      this.state = Object.assign({}, this.state, { documentRequests: data })
    })
  }

  getInteractiveNotes(contactId) {
    this.axios.get(`contacts/${contactId}/record_messages`).then(({data}) => {
      this.state = Object.assign({}, this.state, { interactiveNotes: data })
    })
  }

  getShareInvites(folderId) {
    this.axios.get(`/folders/${folderId}/share_invites`).then(({data}) => {
      let obj = {
        shareInvitesStore: {
          share_invites: data
        }
      }
      this.state = Object.assign({}, this.state, obj)
    })
  }

  getDashboard(params) {
    this.axios.get('dashboard', { params: params }).then(({data}) => {
      let obj = {
        dashboardStore: {
          dashboard: data
        }
      }
      this.state = Object.assign({}, this.state, obj)
    })
  }

  getSentEmails(contactId) {
    this.axios.get(`contacts/${contactId}/sent_emails`).then(({data}) => {
      let obj = {
        sentEmailsStore: {
          sentEmails: data
        }
      }
      this.state = Object.assign({}, this.state, obj)
    })
  }
  getTimeZones() {
    this.axios.get('account_settings/user_profile/time_zones').then(({data}) => {
      this.state = Object.assign({}, this.state, {time_zones: data})
    })
  }

  updateUserProfile(params) {
    return this.axios.patch('account_settings/user_profile', params).then(({data}) => {
      this.state.accountSettings = Object.assign({}, this.state.accountSettings, {userProfile: data})
    })
  }

  updatePasswordProfile(params) {
    return this.axios.patch('account_settings/user_profile/update_password', params)
  }

  updateCompanyUser(userId, params) {
    return this.axios.patch(`account_settings/company/users/${userId}`, params)
  }

  resendInvitation(userId) {
    return this.axios.post(`account_settings/company/users/${userId}/resend_invitation`)
  }

  getStorageQuotas() {
    this.axios.get('account_settings/storages').then(({data}) => {
      this.state = Object.assign({}, this.state, {current_uploads_count: data.current_uploads_count, current_deleted_count: data.current_deleted_count})
    })
  }

  createInvitation(params) {
    return this.axios.post('account_settings/company/users', params)
  }

  createContact(params) {
    return this.axios.post('contacts', params)
  }

  getDeletedResources() {
    this.axios.get('deleted_resources').then(({data}) => {
      this.state = Object.assign({}, this.state, {deletedResources: data})
    })
  }

  restoreDeletedResource(resourceId, params) {
    return this.axios.post(`deleted_resources/${resourceId}/restore`, params)
  }

  restoreAllDeletedResources() {
    return this.axios.post('deleted_resources/restore_all')
  }

  destroyAllDeletedResources() {
    return this.axios.delete('deleted_resources/destroy_all')
  }

  getProducts(params) {
    this.state = Object.assign({}, this.state, { products: {}, meta: {} })

    return this.axios.get('products', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {products: data.data, meta: data.meta})
    })
  }

  createProduct(params) {
    return this.axios.post('products', params)
  }

  updateProduct(productId, params) {
    return this.axios.patch(`products/${productId}`, params)
  }

  getProduct(productId) {
    this.axios.get(`products/${productId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {product: data})
    })
  }

  destroyProduct(product) {
    return this.axios.delete(`products/${product.id}`)
  }

  getTags(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('tags', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { tags: data.data, meta: data.meta  })
    })
  }

  getTag(id) {
    return this.axios.get(`tags/${id}`).then(({data}) => {
      this.state = Object.assign({}, this.state, { tag: data })
    })
  }

  attachProduct(params) {
    return this.axios.post("/connected_tags/", params)
  }

  attachDocumentType(params) {
    return this.axios.post("/connected_tags/", params)
  }

  attachContact(params) {
    return this.axios.post("/connected_tags/", params)
  }

  createTag(params) {
    return this.axios.post('tags', params)
  }

  updateTag(tagId, params) {
    return this.axios.patch(`/tags/${tagId}`, params)
  }

  destroyTag(tagId) {
    return this.axios.delete(`/tags/${tagId}`)
  }

  login(params) {
    return this.axios.post('sessions', params).then(({data}) => {
      this.state = Object.assign({}, this.state, { currentUser: data })
      this.state = Object.assign({}, this.state, { userDefaults: data.defaults })
    })
  }

  logout() {
    return this.axios.delete('sessions').then(() => {
      this.state = {}
    })
  }

  getCurrentUser() {
    return this.axios.get('sessions').then(({data}) => {
      this.state = Object.assign({}, this.state, { currentUser: data.user })
      this.state = Object.assign({}, this.state, { organization: data.organization})
      this.state = Object.assign({}, this.state, { ocrInfo: data.ocr_info })
      this.translations = data.translations
      return data
    })
  }

  getCurrentOrg() {
    return this.axios.get('organization').then(({data}) => {
      this.state = Object.assign({}, this.state, { organization: data })
    })
  }

  newPasswordReset(params) {
    return this.axios.post('password', params)
  }

  submitPasswordReset(params) {
    return this.axios.patch('password', params)
  }

  createDocumentType(params) {
    return this.axios.post('document_types', params)
  }

  getDocumentTypes(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('document_types', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {documentTypes: data.data, meta: data.meta})
    })
  }

  getDocumentType(documentTypeId) {
    this.axios.get(`document_types/${documentTypeId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {documentType: data})
    })
  }

  updateDocumentType(documentTypeId, params) {
    return this.axios.patch(`document_types/${documentTypeId}`, params).then(({data}) => {
      let index = this.state.documentTypes.findIndex(p => p.id === documentTypeId)
      this.state.documentTypes.splice(index, 1, data)
    })
  }

  getSharedRecord(recordId) {
    return this.axios.get(`shared_records/${recordId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {sharedRecord: data})
    })
  }

  getSharedRecordEvents(recordId) {
    this.axios.get(`shared_records/${recordId}/events`).then(({data}) => {
      this.state = Object.assign({}, this.state, {sharedRecordEvents: data})
    })
  }

  getRecord(recordId) {
    return this.axios.get(`records/${recordId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {record: data})
    })
  }

  getRecordVersioned(recordId, id) {
    return this.axios.get(`records/${recordId}/versions/${id}`).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordVersioned: data })
    })
  }

  getRecordEventsVersioned(recordId, id) {
    this.axios.get(`records/${recordId}/versions/${id}/events`).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordEvents: data })
    })
  }

  getRecordNotesVersioned(recordId, id) {
    return this.axios.get(`records/${recordId}/versions/${id}/notes`).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordNotesVersioned: data })
    })
  }

  getRecordMessages(recordId, params = {}) {
    return this.axios.get(`records/${recordId}/messages`, { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordMessages: data })
    })
  }

  createRecordMessage(recordId, params) {
    return this.axios.post(`records/${recordId}/messages`, params)
  }

  createForwardMessage(recordId, recordMessageId, params) {
    return this.axios.post(`records/${recordId}/messages/${recordMessageId}/forward`, params)
  }

  updateRecordMessage(recordId, recordMessageId, params) {
    return this.axios.patch(`records/${recordId}/messages/${recordMessageId}`, params)
  }

  seenRecordMessage(recordId, recordMessageId) {
    return this.axios.patch(`records/${recordId}/messages/${recordMessageId}/seen`)
  }

  updateMessageReactions(id, params) {
    return this.axios.patch(`record_messages/${id}/reactions`, { react: params })
  }

  createReplyRecordMessage(recordId, recordMessageId, params) {
    return this.axios.post(`records/${recordId}/messages/${recordMessageId}/reply`, params)
  }

  destroyRecordMessage(recordId, recordMessageId, params) {
    return this.axios.delete(`records/${recordId}/messages/${recordMessageId}`)
  }

  updateNewVersionOptions(recordId, id, params) {
    return this.axios.patch(`records/${recordId}/versions/${id}`, { version_options: params })
  }

  getRecordVersions(recordId) {
    this.axios.get(`records/${recordId}/versions`).then(({data}) => {
      this.state = Object.assign({}, this.state, {recordVersions: data})
    })
  }

  getRecordEvents(recordId) {
    this.axios.get(`records/${recordId}/events`).then(({data}) => {
      this.state = Object.assign({}, this.state, {recordEvents: data})
    })
  }

  createRecord(params) {
    return this.axios.post('records', params)
  }

  createRecordPresignedUrl(params) {
    return this.axios.post('records/presigned_url', params).then(({data}) => data)
  }

  updateRecord(record, params) {
    return this.axios.patch(`records/${record.id}`, params)
  }

  exportRecord(params) {
    return this.axios.post('export/records', params).then(({data}) => data)
  }

  exportChecklistItems(params) {
    return this.axios.post('export/checklist_items', params)
  }

  copyRecord(record, params) {
    return this.axios.post(`records/${record.id}/copy`, params)
  }

  destroyRecord(record) {
    return this.axios.delete(`records/${record.id}`)
  }

  replaceRecord(record, params) {
    return this.axios.post(`records/${record.id}/replace`, params).then(({data}) => data)
  }

  replaceWithExistingRecord(oldRecord, newRecord) {
    return this.axios.post(`records/${oldRecord}/replace_with_existing_file`, {new_record: newRecord.id}).then(({data}) => data)
  }

  publicReplaceRecord(record, params) {
    return this.axios.post(`public/records/${record.id}/replace`, params).then(({data}) => data)
  }

  markRecordAsStillValid(record, params) {
    return this.axios.post(`public/records/${record.id}/still_valid`, params)
  }

  noReplacementForRecord(record, params) {
    return this.axios.post(`public/records/${record.id}/no_replacement`, params)
  }

  getRecordNotes(recordId) {
    this.axios.get(`records/${recordId}/notes`).then(({data}) => {
      this.state = Object.assign({}, this.state, {recordNotes: data})
    })
  }

  createRecordNote(recordId, params) {
    return this.axios.post(`records/${recordId}/notes`, params)
  }

  createRecordOcr(recordId) {
    return this.axios.post(`records/${recordId}/ocr`)
  }

  destroyRecordNote(recordId, noteId) {
    return this.axios.delete(`records/${recordId}/notes/${noteId}`)
  }

  editRecordNote(recordId, noteId, params) {
    return this.axios.patch(`records/${recordId}/notes/${noteId}`, params)
  }

  publicCreateRecord(params) {
    return this.axios.post('public/records', params)
  }

  publicCreateRecordPresignedUrl(params) {
    return this.axios.post('public/records/presigned_url', params).then(({data}) => data)
  }

  publicSendCongratulations(params){
    return this.axios.post('public/congratulations/send_congratulations', params)
  }

  createVersionRequest(recordId, params) {
    return this.axios.post(`records/${recordId}/version_requests`, params)
  }

  createPicturePresignedUrl(params) {
    return this.axios.post('pictures/presigned_url', params).then(({data}) => data)
  }

  searchResults(params) {
    return this.axios.get('searches', { params: params }).then(({data}) => {
     this.state = Object.assign({}, this.state, { searchResults: data })
    })
  }

  createDocumentRequest(params) {
    return this.axios.post(`document_requests`, params)
  }

  createPublicUploadResponse(params) {
    return this.axios.post(`public/upload_responses`, params)
  }

  getPublicVersionRequest(versionRequestUUID) {
    return this.axios.get(`public/version_requests/${versionRequestUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {versionRequest: data})
    })
  }

  getPublicExpirationPage(expirationPageUUID) {
    return this.axios.get(`public/expiration_pages/${expirationPageUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {expirationPage: data})
    })
  }

  getPublicContactPage(contactUUID) {
    return this.axios.get(`public/contact_pages/${contactUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {contactPage: data})
    })
  }

  getPublicShareInvitation(params) {
    const shareInviteUuid = params.invitation
    return this.axios.get(`public/share_invitations/${shareInviteUuid}`, { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {shareInvitation: data})
    })
  }

  getFolderActivities(folderId, params) {
    return this.axios.get(`folders/${folderId}/activities`, {params: params}).then(({data}) => {
      this.state = Object.assign({}, this.state, { folderActivities: data.data, meta: data.meta })
    })
  }

  createPublicFolderActivity(uuid, params){
    return this.axios.post(`/public/folders/${uuid}/activities`, params)
  }

  createUploadFolderActivity(folderId, params){
    return this.axios.post(`folders/${folderId}/activities`, params)
  }

  getInvitation(invitationId) {
    return this.axios.get(`invitations/${invitationId}/edit`).then(({data}) => {
      this.state = this.state = Object.assign({}, this.state, {invitation: data})
    })
  }

  updateInvitation(InvitationId, params) {
    return this.axios.patch(`invitations/${InvitationId}`, params)
  }

  getNotifications() {
    return this.axios.get('notifications').then(({data}) => {
      this.state = Object.assign({}, this.state, {notifications: data})
    })
  }

  getUnseenNotificationsCount() {
    this.axios.get('notifications/unseen_count').then(({data}) => {
      this.state = Object.assign({}, this.state, {unseenNotificationsCount: data})
    })
  }

  updateNotification(notificationId, params) {
    return this.axios.patch(`notifications/${notificationId}`, params)
  }

  markAllNotificationsSeen() {
    return this.axios.patch(`notifications/mark_all_as_seen`)
  }

  getPublicFolder(folderUUID) {
    this.axios.get(`public/folders/${folderUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {folder: data})
    })
  }

  getPublicSharedFolder(folderUUID) {
    return this.axios.get(`public/shared_folders/${folderUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {sharedFolder: data})
    },
    (err) => {
      this.state = Object.assign({}, this.state, {sharedFolder: err.response.data})
      return err
    })
  }

    authenticatePublicFolder(params) {
        return this.axios.post(`public/shared_folders`, params).then(({data}) => {
      this.state = Object.assign({}, this.state, {sharedFolder: data})
    })
  }

  getChecklistItems(params = {}) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get(`checklist_items`, { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { checklistItems: data.data, meta: data.meta })
    })
  }

  getSharedChecklistItems(params = {}) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get(`shared_checklist_items`, { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { sharedChecklistItems: data.data, meta: data.meta })
    })
  }

  createChecklistItems(params) {
    return this.axios.post('checklist_items', params)
  }

  updateChecklistItem(checklistItemId, params) {
    return this.axios.patch(`checklist_items/${checklistItemId}`, params)
  }

  destroyChecklistItem(checklistItemId, params = {}) {
    return this.axios.delete(`checklist_items/${checklistItemId}`, { params: params } )
  }

  createProductsBulk(params) {
    return this.axios.post(`bulk/products`, params)
  }

  createDocumentTypesBulk(params) {
    return this.axios.post(`bulk/document_types`, params)
  }

  createContactsBulk(params) {
    return this.axios.post(`bulk/contacts`, params)
  }

  createChecklistItemsBulk(params) {
    return this.axios.post(`bulk/checklist_items`, params)
  }

  createTagsBulk(params) {
    return this.axios.post(`bulk/tags`, params)
  }

  removeConnectedTag(tagId, params) {
    return this.axios.delete(`/connected_tags/${tagId}`, { params: params })
  }

  getPublicSharedRecord(folderUUID) {
    this.axios.get(`public/shared_records/${folderUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {sharedRecord: data})
    })
  }

  getPublicRecordMessageSent(msgRecordSentUUID) {
    this.axios.get(`public/record_message_sents/${msgRecordSentUUID}`).then(({data}) => {
      this.state = Object.assign({}, this.state, {recordMessageSent: data})
    })
  }

  getPublicRecordMessageSentLogin(msgRecordSentUUID) {
    this.axios.get(`public/record_message_sents/${msgRecordSentUUID}/record_message_sent_login`).then(({data}) => {
      this.state = Object.assign({}, this.state, {recordMessageSent: data})
    })
  }

  createRecordMessagePublicReply(params) {
    return this.axios.post(`public/record_message_replies`, params)
  }

  executeBulkOperation(operation, list, options) {
    return this.axios.post(`bulk/checklist_items/bulk`, {
      checklist_item_ids: list,
      operation: operation,
      options: options
    })
  }

  bulkCopyRecords(records, folderId) {
    if (records.length === 0 || folderId === null) {
      return
    }
    return this.axios.post(`bulk/records/copy`, { record_id: records, folder_id: folderId })
  }

  bulkRenameFiles(fileName, records, sharedFolder) {
    if(fileName === null || fileName === '') {
      return
    }
    if (records === null || records.length === 0) {
      return
    }
    return this.axios.post(`bulk/records/rename`, { record_id: records, file_name: fileName, shared_folder: sharedFolder })
  }

  getReleaseNotes() {
    return this.axios.get('release_notes').then(({data}) => {
      this.state = Object.assign({}, this.state, {releaseNotes: data})
    })
  }

  bulkDeleteFiles(records, folderId, organizationId) {
    if (records === null || records.length === 0) {
      return
    }

    if (folderId === null) {
      return
    }
    return this.axios.post(`shared_records/destroy_all`, { record_id: records, shared_folder: folderId, organization_id: organizationId })

  }

  sendMetrics(params) {
    return this.axios.post('metrics', params)
  }

  connectSharedTags(formData) {
    return this.axios.post('shared_connected_tags', formData)
  }

  removeSharedConnectedTag(tagId, params) {
    return this.axios.delete(`/shared_connected_tags/${tagId}`, { params: params })
  }

  createSharedTag(params) {
    return this.axios.post('shared_tags', params)
  }

  getCommunicationRecordMessages(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/records', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordMessages: data.data, meta: data.meta })
    })
  }

  showCommunicationRecordMessage(recordMessageId) {
    return this.axios.get(`communications/records/${recordMessageId}`).then(({data}) => {
      this.state = Object.assign({}, this.state, { recordMessage: data })
    })
  }

  deleteRecordMessage(recordMessageIds) {
    return this.axios.post(`communications/records/bulk_destroy`, {'ids': recordMessageIds})
  }

  restoreRecordMessage(recordMessageIds) {
    return this.axios.post(`communications/records/bulk_restore`, {'ids': recordMessageIds})
  }

  getInbox(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/inbox', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {inbox: data.data, meta: data.meta})
    })
  }

  getAttachments(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/attachments', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, { attachments: data.data, meta: data.meta })
    })
  }

  getAutomatedEmails(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/automated_emails', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {automatedEmails: data.data, meta: data.meta})
    })
  }

  getFutureEmails(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/future_emails', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {futureEmails: data.data, meta: data.meta})
    })
  }

  getAllSentEmails(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/sent', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {allSentEmails: data.data, meta: data.meta})
    })
  }

  getTrashEmails(params) {
    this.state = Object.assign({}, this.state, { meta: {} })

    return this.axios.get('communications/trash_emails', { params: params }).then(({data}) => {
      this.state = Object.assign({}, this.state, {trashEmails: data.data, meta: data.meta})
    })
  }

  updateDocumentRequest(documentRequestId, starred) {
    return this.axios.patch(`document_requests/${documentRequestId}`, {'document_request': starred})
  }

  deleteDocumentRequest(documentRequestIds) {
    return this.axios.post(`document_requests/bulk_destroy`, {'ids': documentRequestIds})
  }

  restoreDocumentRequest(documentRequestIds) {
    return this.axios.post(`document_requests/bulk_restore`, {'ids': documentRequestIds})
  }

  updateDocumentResponse(documentRequestId, starred) {
    return this.axios.patch(`document_responses/${documentRequestId}`, {'document_response': starred})
  }

  sendDocumentRequest(documentRequestId) {
    return this.axios.post(`document_requests/${documentRequestId}/send_document_request/`)
  }

  deleteDocumentResponse(documentResponseIds) {
    return this.axios.post(`document_responses/bulk_destroy`, {'ids': documentResponseIds})
  }

  restoreDocumentResponse(documentResponseIds) {
    return this.axios.post(`document_responses/bulk_restore`, {'ids': documentResponseIds})
  }

  updateAutomatedEmails(automatedEmailId, starred) {
    return this.axios.patch(`automated_emails/${automatedEmailId}`, {'sent_email': starred})
  }

  deleteAutomatedEmail(automatedEmailIds) {
    return this.axios.post(`automated_emails/bulk_destroy`, {'ids': automatedEmailIds})
  }

  restoreAutomatedEmail(documentResponseIds) {
    return this.axios.post(`automated_emails/bulk_restore`, {'ids': documentResponseIds})
  }

  getMessage(id, messageType, type) {
    return this.axios.get(`communications/message/${id}/${messageType}`, {params: {type: type}}).then(({data}) => {
      this.state = Object.assign({}, this.state, {message: data})
    })
  }

  getItemFilters() {
    return this.axios.get(`user_filters`).then(({data}) => {
      this.state = Object.assign({}, this.state, { itemFilters: data })
    })
  }

  createItemFilter(params) {
    return this.axios.post('user_filters', params)
  }

  deleteItemFilter(userFilterId) {
    return this.axios.delete(`user_filters/${userFilterId}`)
  }
}

export default Store
